/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Merchant, States, Country } from "../../../../models";
import { MerchantService, SharedFormService } from "../../../../services";

import { faCopy } from "@fortawesome/free-regular-svg-icons";

@Component({
  selector: "app-merchant-address-edit",
  templateUrl: "./merchant-address-edit.component.html"
})
export class MerchantAddressEditComponent implements OnInit {
  @Input() parentGroup!: FormGroup;
  @Input() merchantAddress!: FormGroup;
  @Input() remitToAddress!: FormGroup;
  @Input("merchant") merchant!: Merchant;
  @Output() hasRemitAddress = new EventEmitter<boolean>();
  showRemit = false;
  states = States;
  countries = Country;
  faCopy = faCopy;
  REMIT_TO_ADDRESS = "remitToAddress";

  constructor(private merchantService: MerchantService, private sharedFormService: SharedFormService) {}

  ngOnInit(): void {
    this.showRemit = this.doesRemitAddressExist(this.merchant);
    this.hasRemitAddress.emit(this.showRemit);
  }

  get merchantAddressFormControls() {
    return this.merchantAddress.controls;
  }

  get remitToAddressFormControls() {
    return this.remitToAddress.controls;
  }

  isWorldPay(): boolean {
    return this.merchantService.isWorldPay(this.merchant);
  }

  isInstaMed(): boolean {
    return this.merchantService.isInstaMed(this.merchant);
  }

  doesRemitAddressExist(merchant: Merchant): boolean {
    return !!merchant.remitToAddress && Object.keys(merchant.remitToAddress).length !== 0;
  }

  updateShowRemit() {
    this.showRemit = !this.showRemit;
    if (!this.showRemit) {
      this.parentGroup.removeControl(this.REMIT_TO_ADDRESS);
      this.parentGroup.updateValueAndValidity();
    } else {
      this.parentGroup.setControl(
        this.REMIT_TO_ADDRESS,
        this.sharedFormService.getRemitAddressFormGroup(this.merchant)
      );
    }
    this.hasRemitAddress.emit(this.showRemit);
  }

  copyMerchantAddressToRemitAddress(): any {
    this.remitToAddressFormControls.address1.setValue(this.merchantAddressFormControls.address1.value);
    this.remitToAddressFormControls.address2.setValue(this.merchantAddressFormControls.address2.value);
    this.remitToAddressFormControls.city.setValue(this.merchantAddressFormControls.city.value);
    this.remitToAddressFormControls.state.setValue(this.merchantAddressFormControls.state.value);
    this.remitToAddressFormControls.zip.setValue(this.merchantAddressFormControls.zip.value);
    this.remitToAddressFormControls.country.setValue(this.merchantAddressFormControls.country.value);
  }
}
